module.exports = __webpack_public_path__ + "img/main-banner.dfb29ef2.png";